<template>
    <div class="concierge-detail">
        <div class="contact-container">
            <div class="image" ><img v-if="image" v-bind:src="image.url" v-bind:width="image.width" v-bind:height="image.height" /></div>

            <div class="contact">
                <div class="name">{{name}}</div>
                <div class="addr" v-if="contact">{{contact|addressFormat}}</div>
                <a v-if="contact" v-bind:href="'tel:' + contact.phone" class="phone">{{contact.phone|phoneFormat}}</a>
                <a v-if="contact" v-bind:href="'mailto:' + contact.email" class="email">{{contact.email}}</a>
            </div>
        </div>

        <div class="text">
            <p v-for="(line, index) in linesBio" :key="index">{{line}}</p>
        </div>
    </div>
</template>

<style lang="scss">
.concierge-detail {
    padding-right: 50px;

    .contact-container {
        display: grid;
        grid-template-columns: 100px auto;
        grid-gap: 25px;

        font-size: 18px;
        line-height: 24px;
        margin-bottom: 20px;
    }
    .name {
        font-size: 20px;
        line-height: 26px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .addr {
        margin-bottom: 10px;
    }
    .phone {
        margin-right: 10px;
    }
    .email {
        text-decoration: underline;
    }
    .text {
        font-size: 14px;
        line-height: 18px;
    }
}

.concierge-content-mobile {
    .concierge-detail {
        padding: 20px;

        .contact-container {
            grid-gap: 15px;
        }

        .contact {
            word-break: break-all;
        }

        .phone {
            display: block;
            margin-right: 0;
            margin-bottom: 10px;
        }
        .email {
            display: block;
        }
    }
}
</style>

<script>
import axios from 'axios'

export default {
    name: 'detail',
    data: function () {
        return {
            image: null,
            name: '',
            contact: null,
            bio: ''
        }
    },
    mounted: function () {
        if (typeof window.bs_options === 'undefined') {
            alert('Undefined bs_options')
            return
        }

        this.loadItem()
    },
    computed: {
        linesBio: function () {
            if (this.bio === null) {
                return []
            }

            let value = this.bio.replace(/\r/g, '')
            return value.split('\n')
        }
    },
    methods: {
        loadItem: function () {
            let itemId = this.$route.params.id
            let apiUrl = window.bs_options.api + '/public/affiliate/' + itemId + '?company_id=' + window.bs_options.company_id

            axios.get(apiUrl).then((response) => {
                if (response.status === 404) {
                    this.$router.push({ name: 'list' })
                    return
                }

                if (response.status !== 200 || response.data.error) {
                    alert('Error')
                } else {
                    this.image = response.data.result.image
                    this.name = response.data.result.name
                    this.contact = response.data.result.contact
                    this.bio = response.data.result.bio
                }
            }).catch(() => {
                this.$router.push({ name: 'list' })
            })
        }
    }
}
</script>
